/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_No_Folders_FoundInputs */



/**
* | output |
* | --- |
* | "No folders found." |
*
* @param {Spaces_No_Folders_FoundInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_no_folders_found = /** @type {((inputs?: Spaces_No_Folders_FoundInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_No_Folders_FoundInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine Ordner gefunden.")
	return /** @type {LocalizedString} */ ("No folders found.")
});